import styled from 'astroturf/react';

const CellWithDeletedStatus = styled('span')`
  &.deleted {
    opacity: 0.5;
    text-decoration: line-through;
  }

`;

const CellWithMultiple = styled('span')`
  &:not(:last-child)::after {
    content: ',';
    margin-right: 5px;
  }
`;


export default {
    CellWithDeletedStatus,
    CellWithMultiple
};